"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const labeledItems = [{
  title: "Equipment & apparatus nameplates",
  description: "Engraved stainless and aluminum nameplates for transformers, switchgear, and substation apparatus.",
  link: "/products/engraved-nameplates/equipment-nameplates/"
}, {
  title: "Panel nameplates",
  description: "Control and protection panel identification for substation and plant control rooms.",
  link: "/products/engraved-nameplates/panel-nameplates/"
}, {
  title: "Panel schedules",
  description: "Engraved circuit and device directory plates.",
  link: "/products/electrical-panel-schedules/"
}, {
  title: "Arc flash labels",
  description: "Produced from your arc flash study data for switchgear and electrical rooms.",
  link: "/products/arc-flash-labels/"
}, {
  title: "Cable & conductor ID tags",
  description: "Durable stainless and engraved tags for cable, conductor, and circuit ID.",
  link: "/products/cable-wire-id-tags/"
}, {
  title: "Valve tags & asset tags",
  description: "Brass and stainless valve tags and numbered asset tags for plant systems.",
  link: "/products/engraved-nameplates/valve-tags/"
}];
export default function WhatGetsLabeledInUtilitiesPowerGeneration() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="what-gets-labeled-in-utilities-power-generation" className="bg-[#0F1B2D] py-16 md:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`max-w-3xl mb-12 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl font-bold text-white mb-4">
            What Does Evermark Label for Utilities and Power Plants?
          </h2>
          <p className="text-lg text-gray-300 font-sans">
            The identification Evermark Industrial Solutions produces across substations, switchgear, and generation plants:
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-700 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {labeledItems.map((item, i) => {
          const isNonLink = i === 0 || i === 1 || i === 2 || i === 3 || i === 4 || i === 5;
          const Wrapper = isNonLink ? "div" : Link;
          return <Wrapper key={i} {...!isNonLink ? {
            to: item.link
          } : {}} data-index={i} className="group block h-full focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-xl">
                <Card className="h-full bg-[#1A2A40] border-border/20 hover:border-primary/50 transition-all duration-300 hover:shadow-lg hover:shadow-primary/5 flex flex-col">
                  <CardHeader className="pb-4">
                    <CardTitle className="font-default text-xl text-white group-hover:text-primary transition-colors">
                      {item.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow flex flex-col justify-between">
                    <CardDescription className="text-gray-400 text-base mb-6">
                      {item.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </Wrapper>;
        })}
        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="text-sm text-gray-400 font-sans max-w-4xl">
            High-voltage warning and danger signs are produced to your specified format and the applicable safety-sign standard — see the standards section below.
          </p>
        </div>
      </div>
    </section>;
}